import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_PATIENT_CONSENT_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    1: (oldDoc: Record<string, unknown>) => oldDoc,
    2: (oldDoc: Record<string, unknown>) => ({ ...oldDoc, audience: "ADULT" }),
  };
